/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Magnet(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M127.28929,95.02944a24.00012,24.00012,0,0,1,33.60985-.325c9.693,9.33217,9.46338,25.13406-.0509,34.64834L93.83171,194.34449a8,8,0,0,0-.08742,11.3998L122.3982,234.3982a8,8,0,0,0,11.25812.055l66.46192-65.17456C231.30992,138.087,232.21531,87.284,201.25572,55.862a80.00007,80.00007,0,0,0-113.56441-.43051l-66.103,66.91189a8,8,0,0,0,.03429,11.27921l28.65427,28.65427a8,8,0,0,0,11.37925-.0663Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={126.77456}
        y1={162.39696}
        x2={166.56227}
        y2={202.18467}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={53.95657}
        y1={89.57897}
        x2={93.74372}
        y2={129.36612}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
    </Svg>
  );
}

export default Magnet;
